import { render, staticRenderFns } from "./RemoteSet.vue?vue&type=template&id=f4ab45ec&scoped=true&"
import script from "./RemoteSet.vue?vue&type=script&lang=js&"
export * from "./RemoteSet.vue?vue&type=script&lang=js&"
import style0 from "./RemoteSet.vue?vue&type=style&index=0&id=f4ab45ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ab45ec",
  null
  
)

export default component.exports